import Vue from 'vue';
import LoadingPlugin from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// using default options
Vue.use(LoadingPlugin);
